import OrderEdit from './OrderEdit';
import OrderIcon from '@mui/icons-material/ShoppingBasket';
import OrderList from './OrderList';

export default {
  list: OrderList,
  edit: OrderEdit,
  icon: OrderIcon,
};
